import { styled } from "@mui/material";
import Chip, { ChipProps as MuiFilterProps } from "@mui/material/Chip";

interface StyledFilterProps extends MuiFilterProps {
  isSelected: boolean;
}

export const StyledFilter = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<StyledFilterProps>`
  display: flex;
  align-items: center;
  width: max-content;
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  border-radius: ${(props) => props.theme.wsc.radius.l};
  background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
  border: 1px solid ${(props) => props.theme.wsc.palette.neutral[500]};
  font-size: ${(props) => props.theme.wsc.typography.body2.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body2.fontWeight};
  gap: ${(props) => props.theme.wsc.spacing[0]};
  height: ${(props) => props.theme.wsc.spacing[3]};
  padding: ${(props) =>
    `0 ${props.theme.wsc.spacing[1]} 0 ${props.theme.wsc.spacing[1]}`};

  .MuiChip-label {
    padding: 0;
    ${(props) => props.isSelected && props.theme.wsc.typography.body2bold};
  }

  .MuiButtonBase-root {
    padding: 0;
    margin: 0;
    color: ${(props) => props.theme.wsc.palette.neutral[100]};

    &:hover {
      color: ${(props) => props.theme.wsc.palette.neutral[100]};
    }
  }

  &&:hover {
    background-color: ${(props) => props.theme.wsc.palette.neutral[500]};
    border: 1px solid transparent;
  }

  &.Mui-disabled {
    background-color: transparent;
    color: ${(props) => props.theme.wsc.palette.neutral[300]};
    border-color: transparent;
    opacity: 1;

    button {
      color: ${(props) => props.theme.wsc.palette.neutral[300]};
    }
  }

  ${(props) =>
    props.isSelected &&
    `
    color: ${props.theme.wsc.palette.primary[300]};

    .MuiButtonBase-root {
      color: ${props.theme.wsc.palette.primary[100]};

      &:hover {
        color: ${props.theme.wsc.palette.primary[100]};
      }
    }
  `}
`;
